import { DatabaseEnum } from "@Shape-Digital/kudzu-data/lib/types/common";

import { Appointment } from "./types";

type Role = DatabaseEnum["center_user_role"];

export const checkHasEditRole = (role?: Role) =>
  !!role &&
  ["super_admin", "regional_admin", "receptionist", "technologist"].includes(
    role,
  );

const checkIsCanBeModified = ({
  appointment,
  role,
}: {
  appointment: Appointment;
  role?: Role;
}) => {
  if (!appointment || !checkHasEditRole(role)) {
    return false;
  }

  return !![
    "confirmed",
    "intake_complete",
    "studies_unread",
    "checked_in",
  ].includes(appointment?.status);
};

export default checkIsCanBeModified;
